export const UrlaubsguruRoutes = [
  {
    path: '/deals',
    name: 'Deals',
    component: () =>
      import(
        /* webpackChunkName: "lp-urlaubsguru" */ /* webpackPreload: true */ '../views/Landingpages/Urlaubsguru/Deals.vue'
      ),
    meta: {
      breadcrumb: 'Deals',
    },
  },
]
